
import { filterByCategories } from '../../lib/successStories'
import LargeAccordion from '~/components/LargeAccordion.vue'
import SuccessStoryLink from '~/components/SuccessStoryLink.vue'

export default {
  name: 'SuccessStories',
  components: { LargeAccordion, SuccessStoryLink },
  async asyncData({ $prismic, error }) {
    try {
      const { results } = await $prismic.api.query(
        ['[at(document.type, "role")]'],
        {
          pageSize: 100,
        }
      )

      const successStories = {}
      for (const sector of results) {
        const { results: stories } = await $prismic.api.query(
          [
            '[at(document.type, "success_story")]',
            `[at(my.success_story.role, "${sector.id}")]`,
            '[at(my.success_story.live, true)]',
          ],
          {
            fetchLinks: 'roles.role_type',
            orderings: '[document.last_publication_date desc]',
            pageSize: 6,
          }
        )

        successStories[sector.data.role_type] = {
          name: sector.data.role_type,
          stories,
        }
      }

      return {
        categories: filterByCategories,
        successStories,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Success stories could not be loaded' })
    }
  },

  head: {
    title:
      'Get inspired with our global success stories for any type of role | Nurole',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'See a showcase of some of our successful Nurole candidates and clients for Chair, CEO, CFO, Non-Executive Director, Trustee, Other C-level roles.',
      },
      {
        hid: 'og:description',
        name: 'og:description',
        content:
          'See a showcase of some of our successful Nurole candidates and clients for Chair, CEO, CFO, Non-Executive Director, Trustee, Other C-level roles.',
      },
    ],
  },

  methods: {
    isActive(categoryName) {
      return categoryName === 'By role'
    },
  },
}
